import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UtensilsIcon, SparklesIcon, XIcon, GiftIcon } from 'lucide-react';
export function Header() {
  const [showPromoBanner, setShowPromoBanner] = useState(true);
  return <header className="bg-gradient-to-r from-rose-900 via-rose-800 to-amber-900 shadow-2xl border-b border-rose-700/30" data-id="element-67">
      {/* Iftar Promo Banner */}
      {showPromoBanner && <div className="relative bg-gradient-to-r from-amber-600 via-orange-600 to-rose-600 text-white overflow-hidden" data-id="element-68">
          <div className="absolute inset-0 opacity-20" data-id="element-69">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]" data-id="element-70"></div>
          </div>
          <div className="relative max-w-6xl mx-auto px-4 py-3" data-id="element-71">
            <div className="flex items-center justify-between" data-id="element-72">
              <div className="flex items-center gap-3 flex-1" data-id="element-73">
                <div className="bg-white/20 backdrop-blur-sm rounded-full p-2 animate-pulse" data-id="element-74">
                  <SparklesIcon className="w-5 h-5" data-id="element-75" />
                </div>
                <div className="flex items-center gap-2 flex-wrap" data-id="element-76">
                  <span className="font-bold text-lg tracking-wide" data-id="element-77">
                    🌙 Ramadan Iftar Special
                  </span>
                  <span className="hidden sm:inline text-white/90" data-id="element-78">|</span>
                  <span className="text-sm sm:text-base font-medium" data-id="element-79">
                    Book now and get 20% off for groups of 6+ • Daily Lucky
                    Draws
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-80">
                <Link to="/?package=Ramadan+Iftar+Special" data-id="element-81">
                  <button className="bg-white text-rose-700 hover:bg-rose-50 px-4 py-2 rounded-full font-bold text-sm transition-all transform hover:scale-105 shadow-lg flex items-center gap-2" data-id="element-82">
                    <GiftIcon className="w-4 h-4" data-id="element-83" />
                    View Offers
                  </button>
                </Link>
                <button onClick={() => setShowPromoBanner(false)} className="text-white/80 hover:text-white transition-colors p-1" aria-label="Close banner" data-id="element-84">
                  <XIcon className="w-5 h-5" data-id="element-85" />
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Main Header */}
      <div className="max-w-6xl mx-auto px-4 py-6" data-id="element-86">
        <div className="flex items-center justify-between" data-id="element-87">
          <Link to="/" className="flex items-center gap-3" data-id="element-88">
            <div className="relative" data-id="element-89">
              <UtensilsIcon className="w-10 h-10 text-amber-300" data-id="element-90" />
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-amber-400 rounded-full animate-pulse" data-id="element-91"></div>
            </div>
            <div data-id="element-92">
              <h1 className="text-2xl font-bold text-white tracking-tight" data-id="element-93">
                DineReserve.mv
              </h1>
              <p className="text-xs text-rose-200 font-medium" data-id="element-94">
                Powered by Bank of Maldives
              </p>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-8" data-id="element-95">
            <Link to="/" className="text-white hover:text-amber-300 transition-colors font-semibold tracking-wide" data-id="element-96">
              Restaurants
            </Link>
            <Link to="/promotions" className="text-white hover:text-amber-300 transition-colors font-semibold tracking-wide" data-id="element-97">
              Special Offers
            </Link>
            <Link to="/about" className="text-white hover:text-amber-300 transition-colors font-semibold tracking-wide" data-id="element-98">
              About
            </Link>
            <Link to="/contact" className="text-white hover:text-amber-300 transition-colors font-semibold tracking-wide" data-id="element-99">
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </header>;
}